import { jsxs as i, jsx as a } from "react/jsx-runtime";
import p, { useState as b, useCallback as m, useRef as h, useLayoutEffect as T, useImperativeHandle as I } from "react";
import d from "../../utils/colors.js";
import { Wrapper as v, Tabs as C, TabItem as H, Header as R, ArrowIcon as $, Title as j, Content as k } from "./styled.js";
const G = p.forwardRef(function({ items: c = [], defaultActiveIndex: f = 0, onToggleTab: n }, u) {
  const [t, o] = b(f), l = m(
    () => ({
      open: (r) => {
        o(r);
      }
    }),
    [o]
  ), s = h(l());
  return T(() => {
    s.current = l();
  }, [l]), I(u, () => s.current), /* @__PURE__ */ i(v, { children: [
    /* @__PURE__ */ a(C, { role: "tablist", children: c.map((r, e) => /* @__PURE__ */ a(
      H,
      {
        role: "tab",
        "data-testid": `${r.id}-Tabs`,
        onClick: () => {
          o(e), n && e !== t && n(e);
        },
        $active: t === e,
        "aria-selected": t === e,
        children: /* @__PURE__ */ i(R, { children: [
          /* @__PURE__ */ a($, { fill: t === e ? d.orange : d.blueGrey }),
          /* @__PURE__ */ a(j, { children: r.title })
        ] })
      },
      r.id
    )) }),
    /* @__PURE__ */ a(k, { role: "tabpanel", children: c[t].component })
  ] });
});
export {
  G as Tabs,
  G as default
};
